import React, { useState } from 'react';

const GOLD='#F5A623',DARK='#2C2C2A',NAVY='#1E3A5F',GREEN='#22C55E';
const s = {
  wrap:{minHeight:'100vh',background:'#F4F4F4',fontFamily:"'Syne',sans-serif",display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'},
  card:{background:'#fff',border:'0.5px solid #D3D1C7',borderRadius:'16px',padding:'32px',maxWidth:'520px',width:'100%'},
  btn:{padding:'11px 22px',borderRadius:'10px',fontSize:'13px',fontWeight:700,cursor:'pointer',border:'none',fontFamily:"'Syne',sans-serif"},
  input:{background:'#F4F4F4',border:'0.5px solid #D3D1C7',borderRadius:'9px',padding:'10px 13px',fontSize:'13px',width:'100%',fontFamily:"'Syne',sans-serif",outline:'none',boxSizing:'border-box'},
  label:{fontSize:'10px',fontWeight:700,color:'#888',textTransform:'uppercase',letterSpacing:'.4px',marginBottom:'4px',display:'block'},
};

const api = async (endpoint, options={}) => {
  const token = localStorage.getItem('token');
  const res = await fetch('/api' + endpoint, {
    headers:{'Content-Type':'application/json',...(token?{Authorization:'Bearer '+token}:{})},
    ...options
  });
  return res.json();
};

export default function Onboarding({ user, onComplete }) {
  const [step, setStep] = useState(1);
  const [docsType, setDocsType] = useState('ro');
  const [uploading, setUploading] = useState(false);
  const [uploadedDocs, setUploadedDocs] = useState({});
  const [ocrData, setOcrData] = useState(null);
  const [ocrRunning, setOcrRunning] = useState(false);
  const [vehicleId, setVehicleId] = useState(null);
  const [msg, setMsg] = useState('');
  const [extraDocs, setExtraDocs] = useState({});

  const uploadDoc = async (file, docType) => {
    setUploading(true);
    setMsg('');
    const formData = new FormData();
    formData.append('file', file);
    formData.append('doc_type', docType);
    if (vehicleId) formData.append('vehicle_id', vehicleId);
    const token = localStorage.getItem('token');
    try {
      const res = await fetch('/api/documents/upload', {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + token },
        body: formData
      });
      const data = await res.json();
      if (data.document) {
        setUploadedDocs(prev => ({ ...prev, [docType]: data.document }));
        setMsg('✓ Document încărcat cu succes!');
        return data.document;
      } else {
        setMsg('✗ ' + (data.error || 'Eroare upload'));
      }
    } catch { setMsg('✗ Eroare conexiune'); }
    setUploading(false);
    return null;
  };

  const runOCR = async (documentId, docType) => {
    setOcrRunning(true);
    setMsg('🤖 Se extrag datele prin AI... (10-20 secunde)');
    const data = await api('/ocr/extract', {
      method: 'POST',
      body: JSON.stringify({ document_id: documentId, vehicle_id: vehicleId })
    });
    if (data.success) {
      setOcrData(data.data);
      setMsg('✓ Date extrase automat prin OCR AI!');
      // Creare vehicul din datele OCR
      if (!vehicleId && data.data) {
        await createVehicle(data.data);
      }
    } else {
      setMsg('⚠ OCR nu a putut extrage datele — le vei completa manual.');
    }
    setOcrRunning(false);
  };

  const createVehicle = async (ocrResult) => {
    const vehicleData = {
      plate_number: ocrResult.plate_number || '',
      brand: ocrResult.brand || '',
      model: ocrResult.model || '',
      year: ocrResult.year || '',
      vin: ocrResult.vin || '',
      engine_cc: ocrResult.engine_cc || '',
      power_kw: ocrResult.power_kw || '',
      fuel_type: ocrResult.fuel_type || 'Diesel',
      emission_norm: ocrResult.emission_norm || '',
      docs_type: docsType,
    };
    const data = await api('/vehicles', { method: 'POST', body: JSON.stringify(vehicleData) });
    if (data.vehicle) {
      setVehicleId(data.vehicle.id);
      // Update doc cu vehicle_id
      const docId = uploadedDocs[docsType === 'ro' ? 'talon' : 'acte_strainatate']?.id;
      if (docId) {
        await api('/ocr/extract', {
          method: 'POST',
          body: JSON.stringify({ document_id: docId, vehicle_id: data.vehicle.id })
        });
      }
      return data.vehicle;
    }
    return null;
  };

  const handleFileUpload = async (file, docType) => {
    setUploading(true);
    const doc = await uploadDoc(file, docType);
    if (doc) {
      setUploading(false);
      // Auto OCR pe actele masinii
      if (docType === 'talon' || docType === 'acte_strainatate') {
        await runOCR(doc.id, docType);
      }
    }
    setUploading(false);
  };

  const finishOnboarding = async () => {
    await api('/auth/complete-onboarding', { method: 'POST' });
    onComplete();
  };

  const UploadBox = ({ docType, label, icon, required = false }) => {
    const uploaded = uploadedDocs[docType];
    return (
      <div style={{background:'#F8F8F8',border:`1.5px dashed ${uploaded?GREEN:'#D3D1C7'}`,borderRadius:'12px',padding:'16px',textAlign:'center',marginBottom:'10px'}}>
        <div style={{fontSize:'28px',marginBottom:'8px'}}>{icon}</div>
        <div style={{fontWeight:700,fontSize:'13px',marginBottom:'4px'}}>{label}{required && <span style={{color:'red'}}> *</span>}</div>
        {uploaded ? (
          <div>
            <div style={{fontSize:'11px',color:GREEN,marginBottom:'8px'}}>✓ {uploaded.original_filename}</div>
            {(docType === 'talon' || docType === 'acte_strainatate') && !ocrData && (
              <button onClick={()=>runOCR(uploaded.id, docType)} disabled={ocrRunning}
                style={{...s.btn,background:'#7C3AED',color:'#fff',fontSize:'11px',padding:'6px 14px'}}>
                {ocrRunning ? '⏳ Se procesează...' : '🤖 Extrage date OCR'}
              </button>
            )}
          </div>
        ) : (
          <label style={{...s.btn,background:GOLD,color:DARK,cursor:'pointer',display:'inline-block',padding:'8px 20px'}}>
            {uploading ? '⏳ Se încarcă...' : '+ Încarcă fișier'}
            <input type="file" style={{display:'none'}} accept=".jpg,.jpeg,.png,.pdf,.heic,.webp"
              onChange={e=>{ if(e.target.files[0]) handleFileUpload(e.target.files[0], docType); e.target.value=''; }}
              disabled={uploading}/>
          </label>
        )}
      </div>
    );
  };

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        {/* Header */}
        <div style={{textAlign:'center',marginBottom:'24px'}}>
          <div style={{background:DARK,width:'56px',height:'56px',borderRadius:'14px',display:'inline-flex',alignItems:'center',justifyContent:'center',marginBottom:'12px'}}>
            <span style={{color:GOLD,fontWeight:900,fontSize:'18px'}}>EA</span>
          </div>
          <div style={{fontSize:'22px',fontWeight:800,marginBottom:'4px'}}>dosarmasina.ro</div>
          <div style={{fontSize:'13px',color:'#888'}}>Bun venit, {user.first_name}! Hai să creăm dosarul mașinii tale.</div>
        </div>

        {/* Progress */}
        <div style={{display:'flex',gap:'6px',marginBottom:'24px'}}>
          {[1,2,3].map(i => (
            <div key={i} style={{flex:1,height:'4px',borderRadius:'4px',background:step>=i?GOLD:'#E5E5E5'}}/>
          ))}
        </div>
        <div style={{fontSize:'11px',color:'#888',textAlign:'center',marginBottom:'20px'}}>
          Pasul {step} din 3 — {step===1?'Tipul actelor':step===2?'Încarcă actele mașinii':'Dosar creat!'}
        </div>

        {msg && (
          <div style={{background:msg.includes('✓')?'#DCFCE7':msg.includes('🤖')?'#EDE9FE':msg.includes('⚠')?'#FEF3DC':'#FEE2E2',borderRadius:'8px',padding:'10px',fontSize:'12px',color:msg.includes('✓')?'#15803D':msg.includes('🤖')?'#7C3AED':msg.includes('⚠')?'#D97706':'#B91C1C',marginBottom:'14px'}}>
            {msg}
          </div>
        )}

        {/* STEP 1 — Tip acte */}
        {step === 1 && (
          <div>
            <div style={{fontWeight:700,fontSize:'16px',marginBottom:'16px'}}>📋 Ce tip de acte are mașina ta?</div>
            <div style={{display:'flex',flexDirection:'column',gap:'10px',marginBottom:'20px'}}>
              <div onClick={()=>setDocsType('ro')} style={{border:`2px solid ${docsType==='ro'?GOLD:'#D3D1C7'}`,background:docsType==='ro'?'#FEF3DC':'#fff',borderRadius:'12px',padding:'16px',cursor:'pointer'}}>
                <div style={{fontWeight:700,fontSize:'14px',marginBottom:'4px'}}>🇷🇴 Acte românești</div>
                <div style={{fontSize:'12px',color:'#666'}}>Mașina are talon românesc — înmatriculată în România</div>
              </div>
              <div onClick={()=>setDocsType('foreign')} style={{border:`2px solid ${docsType==='foreign'?GOLD:'#D3D1C7'}`,background:docsType==='foreign'?'#FEF3DC':'#fff',borderRadius:'12px',padding:'16px',cursor:'pointer'}}>
                <div style={{fontWeight:700,fontSize:'14px',marginBottom:'4px'}}>🌍 Acte din străinătate</div>
                <div style={{fontSize:'12px',color:'#666'}}>Mașina vine din import — are acte străine (factură, contract V-C)</div>
              </div>
            </div>
            <button onClick={()=>setStep(2)} style={{...s.btn,background:GOLD,color:DARK,width:'100%'}}>
              Continuă →
            </button>
          </div>
        )}

        {/* STEP 2 — Upload acte */}
        {step === 2 && (
          <div>
            <div style={{fontWeight:700,fontSize:'16px',marginBottom:'16px'}}>
              {docsType==='ro' ? '📋 Încarcă actele mașinii' : '🌍 Încarcă actele din străinătate'}
            </div>

            {docsType === 'ro' ? (
              <UploadBox docType="talon" label="Talon / Certificat de înmatriculare" icon="📋" required/>
            ) : (
              <div>
                <UploadBox docType="acte_strainatate" label="Acte mașină din străinătate" icon="🌍" required/>
                <UploadBox docType="factura_achizitie" label="Factură achiziție / Contract V-C străin" icon="🧾"/>
              </div>
            )}

            {ocrData && (
              <div style={{background:'#F0FDF4',border:'1px solid #86EFAC',borderRadius:'10px',padding:'14px',marginBottom:'14px'}}>
                <div style={{fontWeight:700,color:GREEN,marginBottom:'8px',fontSize:'13px'}}>✓ Date extrase automat prin OCR:</div>
                <div style={{display:'flex',flexWrap:'wrap',gap:'6px'}}>
                  {Object.entries(ocrData).filter(([k,v])=>v&&v!=='null'&&v!=='').map(([k,v])=>(
                    <div key={k} style={{background:'#fff',border:'0.5px solid #86EFAC',borderRadius:'6px',padding:'3px 8px',fontSize:'11px'}}>
                      <span style={{color:'#888'}}>{k}: </span><strong>{String(v)}</strong>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div style={{display:'flex',gap:'8px'}}>
              <button onClick={()=>setStep(1)} style={{...s.btn,background:'#F4F4F4',color:'#555',border:'0.5px solid #D3D1C7',flex:1}}>
                ← Înapoi
              </button>
              <button
                onClick={async()=>{
                  if (!uploadedDocs['talon'] && !uploadedDocs['acte_strainatate']) {
                    setMsg('⚠ Te rugăm să încarci actele mașinii pentru a continua!');
                    return;
                  }
                  if (!vehicleId && ocrData) await createVehicle(ocrData);
                  else if (!vehicleId) {
                    const v = await api('/vehicles', {
                      method:'POST',
                      body: JSON.stringify({ plate_number:'', brand:'', model:'', year:'', fuel_type:'Diesel', docs_type: docsType })
                    });
                    if (v.vehicle) setVehicleId(v.vehicle.id);
                  }
                  setStep(3);
                }}
                style={{...s.btn,background:GOLD,color:DARK,flex:2}}>
                Continuă →
              </button>
            </div>
          </div>
        )}

        {/* STEP 3 — Finalizare */}
        {step === 3 && (
          <div style={{textAlign:'center'}}>
            <div style={{fontSize:'56px',marginBottom:'16px'}}>🎉</div>
            <div style={{fontSize:'20px',fontWeight:800,marginBottom:'8px'}}>Dosar creat cu succes!</div>
            {ocrData && (
              <div style={{background:'#F0FDF4',border:'1px solid #86EFAC',borderRadius:'10px',padding:'14px',marginBottom:'16px',textAlign:'left'}}>
                <div style={{fontWeight:700,color:GREEN,marginBottom:'6px',fontSize:'12px'}}>✓ Mașina identificată:</div>
                <div style={{fontSize:'14px',fontWeight:700}}>
                  {ocrData.plate_number || ocrData.vin || 'Vehicul nou'}
                </div>
                <div style={{fontSize:'12px',color:'#555',marginTop:'2px'}}>
                  {[ocrData.brand, ocrData.model, ocrData.year].filter(Boolean).join(' ')}
                </div>
              </div>
            )}
            <div style={{fontSize:'13px',color:'#666',marginBottom:'20px',lineHeight:1.6}}>
              Dosarul mașinii tale a fost creat! Acum poți adăuga restul documentelor, seta expirările și genera acte auto.
            </div>
            <button onClick={finishOnboarding} style={{...s.btn,background:GOLD,color:DARK,width:'100%',fontSize:'14px',padding:'14px'}}>
              Intră în platformă →
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
